import { __decorate as e, __classPrivateFieldGet as t, __classPrivateFieldSet as s } from "tslib";
import { LitElement as i, html as o } from "lit";
import { property as r } from "lit/decorators.js";
import l from "../styles/global-styles.js";
import n from "./footer-styles.js";
import a from "@inera/ids-design/components/footer/footer-lit.js";
var d, h, c, u, f, p, m, b, v;
class _ extends i {
  constructor() {
    super(...arguments), d.set(this, ""), h.set(this, ""), c.set(this, ""), u.set(this, 3), f.set(this, "2"), p.set(this, "2"), m.set(this, "2"), b.set(this, ""), v.set(this, void 0);
  }
  get headline() {
    return t(this, d, "f");
  }
  set headline(e) {
    s(this, d, e, "f");
  }
  get srheadline() {
    return t(this, h, "f");
  }
  set srheadline(e) {
    s(this, h, e, "f");
  }
  get subheadline() {
    return t(this, c, "f");
  }
  set subheadline(e) {
    s(this, c, e, "f");
  }
  get cols() {
    return t(this, u, "f");
  }
  set cols(e) {
    s(this, u, e, "f");
  }
  get linkcol1() {
    return t(this, f, "f");
  }
  set linkcol1(e) {
    s(this, f, e, "f");
  }
  get linkcol2() {
    return t(this, p, "f");
  }
  set linkcol2(e) {
    s(this, p, e, "f");
  }
  get linkcol3() {
    return t(this, m, "f");
  }
  set linkcol3(e) {
    s(this, m, e, "f");
  }
  get servicename() {
    return t(this, b, "f");
  }
  set servicename(e) {
    s(this, b, e, "f");
  }
  get type() {
    return t(this, v, "f");
  }
  set type(e) {
    s(this, v, e, "f");
  }
  get mobileMenu() {
    return this.querySelector("ids-mobile-menu");
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.setupColSize(), this.classList.add(`ids-type-${this.type}`), this.setupMobileMenu(), this.setupLinks(), this.setupSubLinks(), this.setupSubLinksRight();
  }
  setupColSize() {
    1 === this.cols ? (this.linkcol1 = "6", this.linkcol2 = "6", this.linkcol3 = "6") : 2 === this.cols && (this.linkcol1 = "3", this.linkcol2 = "3", this.linkcol3 = "3");
  }
  setupMobileMenu() {
    this.mobileMenu?.setAttribute("slot", "mobile-menu"), this.mobileMenu?.setAttribute("variation", "2");
  }
  setupLinks() {
    this.querySelectorAll("ids-link").forEach(e => {
      "inera" === this.type ? e.setAttribute("light", "true") : "1177-pro" === this.type ? e.setAttribute("colorpreset", "1") : e.setAttribute("colorpreset", "2");
    });
  }
  setupSubLinks() {
    this.querySelectorAll('ids-link[slot="sub-footer-right"]').forEach(e => {
      e.setAttribute("light", "true"), "1177" != this.type && "1177-pro" != this.type || e.setAttribute("outline", " var(--IDS-COLOR-NEUTRAL-100)"), e.setAttribute("size", "0.875rem");
    });
  }
  setupSubLinksRight() {
    this.querySelectorAll('ids-link[slot="sub-footer-links"]').forEach(e => {
      "1177-pro" == this.type ? e.setAttribute("colorpreset", "1") : e.setAttribute("light", "true"), e.setAttribute("underlined", "true"), e.setAttribute("block", "true"), e.setAttribute("size", "0.875rem"), e.setAttribute("padding", "15px 0px");
    });
  }
  renderLogo() {
    switch (this.type) {
      case "1177":
        return o`<ids-icon-1177 color="white" width="90" height="34"></ids-icon-1177><div class="ids-footer__sub-footer-mobile-text"><slot name="sub-footer-mobile"></slot></div>`;
      case "1177-pro":
        return o`<div class="ids-footer__sub-footer-mobile-icon"><ids-icon-1177 color="var(--IDS-COLOR-ACCENT-40)" width="45" height="18"></ids-icon-1177><div class="ids-footer__sub-footer-mobile-service-name"><p style="color:var(--IDS-COLOR-ACCENT-30);font-weight:700;line-height:13px;letter-spacing:-.253846px">${this.servicename}</p></div></div><div class="ids-footer__sub-footer-mobile-text"><slot name="sub-footer-mobile"></slot></div>`;
      case "inera-admin":
        return o`<slot name="sub-footer-mobile"></slot>`;
      case "inera-admin-legacy":
        return o`<ids-container><ids-row justify="center"><ids-col class="footer-sub-text" cols="auto">${this.servicename ? o`<p style="color:var(--color-grey-base);font-size:.875rem">${this.servicename} drivs av Inera på uppdrag av Sveriges regioner.</p>` : o``}</ids-col></ids-row></ids-container>`;
      case "inera":
        return o`<div style="color:var(--IDS-COLOR-NEUTRAL-100);font-size:.875rem">Inera AB ägs av SKR, regioner och kommuner.</div>`;
      default:
        return o``;
    }
  }
  renderHeadline() {
    switch (this.type) {
      case "1177":
      case "inera":
      case "inera-admin":
      case "inera-legacy":
      case "inera-admin-legacy":
        return this.renderHeadlineElements();
      case "1177-pro":
        return o`<h1 class="ids-footer__headline">${this.servicename}</h1>`;
    }
  }
  renderHeadlineElements() {
    return this.srheadline ? o`<h1 class="ids-footer__headline--sr">${this.srheadline} <span class="ids-footer__headline--sub">${this.subheadline}</span></h1><h1 aria-hidden="true" class="ids-footer__headline">${this.headline} <span class="ids-footer__headline--sub">${this.subheadline}</span></h1>` : o`<h1 class="ids-footer__headline">${this.headline} <span class="ids-footer__headline--sub">${this.subheadline}</span></h1>`;
  }
  getColumnWidth(e) {
    const t = "ids-footer__col-size-";
    switch (e) {
      case 1:
        return t + this.linkcol1;
      case 2:
        return t + this.linkcol2;
      case 3:
        return t + this.linkcol3;
      default:
        return 2;
    }
  }
  renderCols() {
    return 1 === this.cols ? o`<div class="ids-footer__link-col ids-footer__link-col--1 ${this.getColumnWidth(1)}"><slot name="link-col-1"></slot></div>` : 2 === this.cols ? o`<div class="ids-footer__link-col ids-footer__link-col--2 ${this.getColumnWidth(1)}"><slot name="link-col-1"></slot></div><div class="ids-footer__link-col ids-footer__link-col--2 ${this.getColumnWidth(2)}"><slot name="link-col-2"></slot></div>` : o`<div class="ids-footer__link-col ${this.getColumnWidth(1)}"><slot name="link-col-1"></slot></div><div class="ids-footer__link-col ${this.getColumnWidth(2)}"><slot name="link-col-2"></slot></div><div class="ids-footer__link-col ${this.getColumnWidth(3)}"><slot name="link-col-3"></slot></div>`;
  }
  render() {
    return o`<footer class="ids-footer ids-footer--${this.type}"><div class="ids-footer__inner-wrapper"><div class="ids-footer__inner"><div class="ids-footer__headline-row">${this.renderHeadline()}</div><div class="ids-footer__content"><div class="ids-footer__text"><slot></slot></div>${this.renderCols()}</div></div></div><div class="ids-footer__sub-footer"><div class="ids-footer__sub-footer-container"><div class="ids-footer__sub-footer-row"><div class="ids-footer__sub-footer-left"><slot name="sub-footer-left"></slot></div><div class="ids-footer__sub-footer-right"><slot name="sub-footer-right"></slot></div><div cols="12" class="ids-footer__mobile-menu"><slot name="mobile-menu"></slot></div><div class="ids-footer__mobile-links"><slot name="sub-footer-links"></slot></div></div></div><div class="ids-footer__sub-footer-mobile">${this.renderLogo()}</div></div></footer>`;
  }
}
d = new WeakMap(), h = new WeakMap(), c = new WeakMap(), u = new WeakMap(), f = new WeakMap(), p = new WeakMap(), m = new WeakMap(), b = new WeakMap(), v = new WeakMap(), _.styles = [l, a, n], e([r({
  type: String
})], _.prototype, "headline", null), e([r({
  type: String
})], _.prototype, "srheadline", null), e([r({
  type: String
})], _.prototype, "subheadline", null), e([r({
  type: Number,
  reflect: !0
})], _.prototype, "cols", null), e([r({
  type: String,
  reflect: !0
})], _.prototype, "linkcol1", null), e([r({
  type: String,
  reflect: !0
})], _.prototype, "linkcol2", null), e([r({
  type: String,
  reflect: !0
})], _.prototype, "linkcol3", null), e([r({
  type: String
})], _.prototype, "servicename", null), e([r({
  type: String,
  reflect: !0
})], _.prototype, "type", null);
export { _ as IDSFooter };